import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../lib/api';
import { Shield, CheckCircle2, XCircle } from 'lucide-react';

export default function VerifyEmailPage() {
  const { token } = useParams();
  const [status, setStatus] = useState('verifying');
  const [error, setError] = useState('');

  useEffect(() => {
    (async () => {
      try {
        await api.get(`/verify/email/confirm/${token}`);
        setStatus('verified');
      } catch (e) {
        setError(e.response?.data?.detail || 'Verification failed');
        setStatus('failed');
      }
    })();
  }, [token]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-white border border-gray-200 rounded-lg p-8 text-center">
        <div className="flex items-center justify-center gap-2 mb-6">
          <div className="w-8 h-8 bg-[#0055FF] flex items-center justify-center rounded"><Shield className="w-5 h-5 text-white" /></div>
          <span className="font-heading text-lg font-semibold">LeadXchange</span>
        </div>
        {status === 'verifying' && <div className="text-gray-600 font-mono text-sm">Verifying your email…</div>}
        {status === 'verified' && (
          <>
            <CheckCircle2 className="w-12 h-12 text-green-600 mx-auto mb-3" />
            <h1 className="font-heading text-xl font-semibold text-gray-900 mb-2" data-testid="email-verified-title">Email verified</h1>
            <p className="text-sm text-gray-600 mb-4">Your email address has been confirmed. Your trust score has been updated.</p>
            <Link to="/verification" className="inline-block px-4 py-2 bg-[#0055FF] hover:bg-[#0044CC] text-white rounded text-sm font-medium">Continue to verification</Link>
          </>
        )}
        {status === 'failed' && (
          <>
            <XCircle className="w-12 h-12 text-red-600 mx-auto mb-3" />
            <h1 className="font-heading text-xl font-semibold text-gray-900 mb-2">Verification failed</h1>
            <p className="text-sm text-gray-600 mb-4">{error}</p>
            <Link to="/verification" className="text-[#0055FF] text-sm underline">Request a new link</Link>
          </>
        )}
      </div>
    </div>
  );
}
